class ShareButton extends HTMLElement {
  constructor () {
    super()
    this.urlToShare = document.location.href
    this.label = this.querySelector('[data-button-label]')
    this.shareLabel = window.shareStrings.copyToClipboard
    this.successLabel = window.shareStrings.successMessage
    this.shareLabelError = window.shareStrings.copyToClipboardError
    this.shareUrlError = window.shareStrings.shareUrlError

    if (!navigator.share && navigator.clipboard) {
      this.label.innerHTML = window.shareStrings.copyToClipboard
    }
    this.addEventListener('click', (event) => this.runShareAction(event, this))
    this.addEventListener('keydown', (event) => this.shareKeyboardEvent(event, this))
  }

  shareKeyboardEvent (event, returnFocusTarget) {
    const isTrigger = event.key === 'Enter' || event.key === 'Spacebar' || event.key === ' ' || event.key === 32
    if (isTrigger) {
      this.runShareAction(event, returnFocusTarget)
    }
  }

  runShareAction (event, returnFocusTarget) {
    event.preventDefault()
    event.stopPropagation()
    if (!navigator.share && navigator.clipboard) {
      navigator.clipboard.writeText(this.urlToShare).then(() => {
        this.label.innerHTML = this.successLabel
        setTimeout(() => {
          this.label.innerHTML = this.shareLabel
        }, 2000)
      }).catch(error => {
        if (error) {
          console.log(this.shareLabelError)
        }
      }).finally(() => {
        returnFocusTarget.focus()
      })
    } else {
      return this.openNavigatorShare(event, returnFocusTarget)
    }
  }

  openNavigatorShare (event, returnFocusTarget) {
    navigator.share({
      url: this.urlToShare,
      title: document.title
    }).catch((error) => {
      if (error) {
        console.log(this.shareUrlError, error)
      }
    }).finally(() => {
      // Return focus to the share button
      returnFocusTarget.focus()
    })
    return false
  }
}

if (!customElements.get('share-button')) {
  customElements.define('share-button', ShareButton)
}
